import moment from 'moment';

import constants from '@/common/constants';
import Utils from '@/common/utils';

import { TStatisticsPublicFilter } from '../types/statistics/statistics-public';

export default {
  exportExcel: function (request: TStatisticsPublicFilter) {
    return Utils.downloadFile(
      'api/auditpublicstatistic/exportexcel',
      `Website_statistics_public_${moment().format(constants.DATE_FORMATS['YYYYMMDD'])}.xlsx`,
      request,
      true,
    );
  },
};
